export const CampaignTypes = [
  { key: "trivia", label: "Bilgi Yarışması" },
  { key: "lottery", label: "Çekiliş" },
  { key: "wof", label: "Şans Çarkı" },
];
